import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=1327dc86"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=1327dc86&prod&lang=css"
import style1 from "./AppHeader.vue?vue&type=style&index=1&id=1327dc86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports